// eslint-disable-next-line no-restricted-imports
import { Trans } from '@lingui/macro'
import Circle from 'assets/images/white-loader.svg'
import CopyIcon from 'assets/svg/copy-icon.svg'
import { ButtonPrimary } from 'components/Button'
import { TruncatedText } from 'components/swap/styleds'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { useReferralsVaultContract } from 'hooks/useContract'
import React, { useEffect, useState } from 'react'
import { useWalletModalToggle } from 'state/application/hooks'
import { useDarkModeManager } from 'state/user/hooks'
import styled from 'styled-components/macro'
import { ButtonText, CustomLightSpinner, ThemedText } from 'theme'
import { getFullDisplayBalance } from 'utils/formatBalance'
import { isMobile } from 'utils/userAgent'

import useGetPublicPoolData from './hooks/useGetPublicPoolData'
import useGetWalletPoolData from './hooks/useGetWalletPoolData'
import ReferralsList from './ReferralsList'

const PageWrapper = styled.div`
  max-width: 600px;
  width: 100%;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    max-width: 500px;
  `};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    max-width: 400px;
    margin-top: 5rem;
  `};
`

const DataContentWrapper = styled.main`
  background-color: ${({ theme }) => theme.bg0};
  border-radius: 8px;
  border: 1px solid #8247e5;
  padding: 16px;
  margin-top: 2rem;
`

function Referrals() {
  const { account, chainId } = useActiveWeb3React()
  const toggleWalletModal = useWalletModalToggle()
  const [darkMode] = useDarkModeManager()

  const [attempting, setAttempting] = useState<boolean>(false)
  const [isCopied, setIsCopied] = useState(false)
  const [link, setLink] = useState('')
  useEffect(() => {
    if (account) {
      const refLink = `https://casino.shiba-worldsports.io?ref=${account}`
      setLink(refLink)
    }
  }, [account])
  const copyTextToClipboard = (text: string | undefined) => {
    if (text !== undefined && 'clipboard' in navigator) {
      return navigator.clipboard.writeText(text)
    }
    return document.execCommand('copy', true, text)
  }
  const handleCopyClick = (copyText: string | undefined) => {
    try {
      copyTextToClipboard(copyText)
      setIsCopied(true)
      setTimeout(() => {
        setIsCopied(false)
      }, 5000)
    } catch (error) {
      setIsCopied(false)
    }
  }

  const poolData = useGetPublicPoolData()
  const walletData = useGetWalletPoolData()
  const vaultContract = useReferralsVaultContract()

  const handleClaim = async () => {
    try {
      setAttempting(true)
      const response = await vaultContract?.harvest()?.catch(() => {
        setAttempting(false)
      })
      await response?.wait()

      if (response?.hash) setAttempting(false)

      walletData.fetchWalletData()
    } catch (error) {
      console.log(error)
      setAttempting(false)
    }
  }

  const { points, earned } = walletData

  const haveEarns = earned.gt(0)

  const totalPoints = getFullDisplayBalance(poolData.totalPoints, 0, 0)
  const totalHolders = poolData.holders
  const onPool = points.gt(0)

  const referralUrl = `https://casino.shiba-worldsports.io?ref=${account}`

  return (
    <PageWrapper>
      <DataContentWrapper>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <ThemedText.LargeHeader fontSize={isMobile ? '2rem' : '3rem'}>
            <Trans>Referrals Pool</Trans>
          </ThemedText.LargeHeader>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {darkMode ? (
            <img width={isMobile ? 150 : 200} src={`${process.env.PUBLIC_URL}/images/casino-chips-ico.svg`} alt="" />
          ) : (
            <img
              width={isMobile ? 150 : 200}
              src={`${process.env.PUBLIC_URL}/images/casino-chips-ico-black.svg`}
              alt=""
            />
          )}
        </div>
        {account ? (
          <>
            {haveEarns && (
              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
                <ThemedText.LargeHeader color="#eab308">
                  <Trans>Rewards</Trans> {getFullDisplayBalance(earned, 18, 4)} SWC
                </ThemedText.LargeHeader>
              </div>
            )}
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
              <ThemedText.Body fontSize={isMobile ? '0.8rem' : '1rem'}>
                <Trans>Your referral URL</Trans>
              </ThemedText.Body>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '0.5rem' }}>
              <ButtonText onClick={() => handleCopyClick(link)}>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  <ThemedText.Body color="#3b82f6" mr="0.2rem" fontSize={isMobile ? '0.6rem' : '0.8rem'}>
                    <TruncatedText>{referralUrl}</TruncatedText>
                  </ThemedText.Body>
                  <img src={CopyIcon} alt="" width={24} />
                </div>
                <ThemedText.Body color="#3b82f6" fontSize={isMobile ? '0.6rem' : '0.8rem'}>
                  {isCopied ? <Trans>Copied!</Trans> : ''}
                </ThemedText.Body>
              </ButtonText>
            </div>
          </>
        ) : (
          ''
        )}
        {onPool && (
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                marginTop: '1rem',
              }}
            >
              <ThemedText.Body fontSize={isMobile ? '0.8rem' : '1rem'} color="#3b82f6">
                <Trans>Your points</Trans>:
              </ThemedText.Body>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                marginTop: '1rem',
              }}
            >
              <ThemedText.Body fontSize={isMobile ? '0.8rem' : '1rem'}>{points.toFixed()}</ThemedText.Body>
            </div>
          </div>
        )}
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: !onPool ? '' : '1rem',
              gap: '0.5rem',
            }}
          >
            <ThemedText.Body fontSize={isMobile ? '0.8rem' : '1rem'} color="#3b82f6">
              <Trans>Total points:</Trans>
            </ThemedText.Body>
            <ThemedText.Body fontSize={isMobile ? '0.8rem' : '1rem'} color="#3b82f6">
              Holders:
            </ThemedText.Body>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: !onPool ? '' : '1rem',
              gap: '0.5rem',
            }}
          >
            <ThemedText.Body fontSize={isMobile ? '0.8rem' : '1rem'}>{totalPoints}</ThemedText.Body>
            <ThemedText.Body fontSize={isMobile ? '0.8rem' : '1rem'}>{totalHolders}</ThemedText.Body>
          </div>
        </div>
        <div style={{ width: '80%', marginLeft: '10%', marginTop: '2rem' }}>
          {account ? (
            haveEarns && (
              <ButtonPrimary
                style={{ marginTop: '1rem', padding: '8px 16px' }}
                onClick={handleClaim}
                disabled={attempting}
              >
                {attempting ? (
                  <>
                    <Trans>Claiming </Trans>{' '}
                    <CustomLightSpinner
                      src={Circle}
                      alt="loader"
                      size={'18px'}
                      style={{ marginLeft: '0.5em', textDecoration: 'bold' }}
                    />{' '}
                  </>
                ) : (
                  <Trans>Claim</Trans>
                )}
              </ButtonPrimary>
            )
          ) : (
            <ButtonPrimary style={{ marginTop: '1rem', padding: '8px 16px' }} onClick={toggleWalletModal}>
              <Trans>Connect a wallet</Trans>
            </ButtonPrimary>
          )}
        </div>
      </DataContentWrapper>
      {account && <ReferralsList />}
    </PageWrapper>
  )
}

export default Referrals
